module.exports = __webpack_public_path__ + "img/7.bad_smell.add36025.svg";